var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Yandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.009,23.496c0,-11.312 9.183,-20.495 20.496,-20.495c11.313,0 20.496,9.183 20.496,20.495c0,11.312 -9.183,20.495 -20.496,20.495c-11.313,0 -20.496,-9.183 -20.496,-20.495zM26,35.507v-10.382l8.549,-8.559c0.585,-0.587 0.585,-1.537 0,-2.121c-0.587,-0.585 -1.537,-0.585 -2.121,0l-7.931,7.939l-7.931,-7.939c-0.585,-0.585 -1.535,-0.585 -2.121,0c-0.585,0.585 -0.585,1.535 0,2.121l8.555,8.563v10.377c0,0.828 0.672,1.5 1.5,1.5c0.827,0.001 1.5,-0.671 1.5,-1.499z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Yandex);
export default __webpack_public_path__ + "static/media/icons8-yandex.ae479b65ca66f42c690a8cff42feb72e.svg";
export { ForwardRef as ReactComponent };